export const PANIC_ALERT_EVENT_NAMES = ["panic:alert", ".panic:alert"] as const;

export function subscribePanicEvents(handler: (event: Event) => void): () => void {
  PANIC_ALERT_EVENT_NAMES.forEach((name) => window.addEventListener(name, handler));
  return () => {
    PANIC_ALERT_EVENT_NAMES.forEach((name) => window.removeEventListener(name, handler));
  };
}

export function dispatchPanicAlertGate(panicAlertId: number): void {
  window.dispatchEvent(
    new CustomEvent("panic:alert", {
      detail: {
        panic_alert_id: panicAlertId,
      },
    }),
  );
}

export function readPanicAlertId(detail: unknown): number | null {
  const record =
    detail && typeof detail === "object" && !Array.isArray(detail)
      ? (detail as Record<string, unknown>)
      : null;
  if (!record) {
    return null;
  }

  const id = record.panic_alert_id ?? record.id ?? record.alert_id;
  if (typeof id === "number" && Number.isFinite(id)) {
    return id;
  }
  if (typeof id === "string") {
    const parsed = Number(id);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}
